export enum ModelSelectionOptions {
  ModelBased = 'model-based',
  NoModel = 'no-model',
}

export enum SleeveManagementSteps {
  SleeveDetails = 'sleeveDetails',
  ModelCustomization = 'modelCustomization',
  AllocateFunds = 'allocateFunds',
}

export enum RebalanceOptions {
  Enabled = 'enabled',
  ViolationsOnly = 'violations_only',
  Never = 'never',
}

export enum SleeveCustomizationStatus {
  Unedited = 'unedited',
  Edited = 'edited',
  Removed = 'removed',
  New = 'new', // newly added customization
  Custom = 'custom',
}
